import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import './decomp-model-waterfall.component.scss';

import { useLineChartData2 } from '../hooks/use-waterfall-chart-data.hook';
import { WaterfallData } from '../hooks/waterfall-data.interface';

interface DecompModelSparkLineComponentProps {
  chartData?: WaterfallData;
  aspectRatio?: number;
  displayAxis?: boolean;
  height?: number;
}

export const DecompModelSparkLineComponent = ({
  chartData,
  aspectRatio,
  displayAxis = false,
  height,
}: DecompModelSparkLineComponentProps) => {
  const chartLineData = useLineChartData2(chartData?.children);

  const options: any = useMemo(() => {
    return {
      aspectRatio,

      plugins: {
        title: {
          display: false,
        },
        legend: {
          display: false,
        },

        // tooltip: {
        //   position: 'average',
        //   enabled: true,
        // }
      },
      responsive: true,
      parsing: {
        xAxisKey: 'label',
        yAxisKey: 'value',
      },
      scales: {
        x: {
          display: displayAxis,
        },
        y: {
          display: displayAxis,
          beginAtZero: false,
        },
      },
    };
  }, [aspectRatio, displayAxis]);
  return <Line height={height} options={options} data={chartLineData} />;
};
